/**
 * Gets the active panel of the form
 */
export default function getActivePanel(form) {
  return form.querySelector('.lead-constructor__panel.active');
}
